import type { ReactNode } from 'react';

interface BadgeProps {
  variant: 'pending' | 'error' | 'success' | 'info';
  children: ReactNode;
  /** xs = smaller text + padding, sm = standard. Default: xs */
  size?: 'xs' | 'sm';
  className?: string;
}

const variantClasses = {
  pending: 'text-yellow-600 bg-yellow-100 dark:bg-yellow-900/40 dark:text-yellow-300',
  error: 'text-red-600 bg-red-100 dark:bg-red-900/40 dark:text-red-300',
  success: 'text-green-600 bg-green-100 dark:bg-green-900/40 dark:text-green-300',
  info: 'text-blue-600 bg-blue-100 dark:bg-blue-900/40 dark:text-blue-300',
} as const;

const sizeClasses = {
  xs: 'text-xs px-1.5 py-0.5',
  sm: 'text-sm px-2 py-0.5',
} as const;

export default function Badge({ variant, children, size = 'xs', className = '' }: BadgeProps) {
  return (
    <span className={`inline-flex items-center rounded font-medium ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}>
      {children}
    </span>
  );
}
